<template>
    <div
        ref="wrap"
        class="app-virtual-table-dynamic-wrap">
        <app-virtual-table
            class="app-virtual-table-dynamic"
            :class="{ 'app-data-table-editable': canEdit }"
            :items="items"
            :headers="headers"
            :total-items="totalItems"
            :loading="loading"
            :loaded-ranges="loadedRanges"
            :sort-by="currentSortBy"
            :sort-desc="currentSortDesc"
            @update:sort-by="currentSortBy = $event"
            @update:sort-desc="currentSortDesc = $event"
            @load-range="loadRange"
            @click:row="viewItem">
            <template v-for="field in fieldKeys" #[`item.${field}`]="{ item }">
                <component
                    :is="getCellComponent(field)"
                    :key="field"
                    :options="getCellOptions(field)"
                    :value="item[field]"
                    :class="{ 'clickable': canView }"
                    @refresh="refresh" />
            </template>
            <template #[`item.actions`]="{ item }">
                <div class="no-overflow-ellipsis">
                    <v-icon
                        v-if="canEdit"
                        class="edit-button"
                        small
                        color="primary"
                        @click.stop="$emit('edit', item)">
                        mdi-pencil
                    </v-icon>
                    <slot name="extra-actions" :item="item" />
                </div>
            </template>
        </app-virtual-table>
    </div>
</template>

<script>
import virtualDataTableMixin from "@/features/virtualTable/mixins/virtualDataTableMixin";
import { equal, notEqual, and } from "@/features/schemas/services/schemaFiltering";
import { applyForeignKeySorting} from "@/features/schemas/services/tableService";

export default {
    mixins: [virtualDataTableMixin],
    types: [
        "project"
    ],
    computed: {
        requestModel() {
            const fixedFilters = this
                .fixedFields
                .map(f => equal(this.entityKey, f, this.fixedValues[f]));

            const filters = [...fixedFilters, this.filter].filter(f => f != null);
            filters.push(notEqual(this.entityKey, "projectStatus", 0));
            const filter = filters.length ? and(filters) : null;

            let options = this.options;
            if (options) {
                options.sortBy = applyForeignKeySorting(this.entityKey, options.sortBy);
            }
            if (!options?.sortBy && this.sortBy) {
                options = options ?? {};
                options.sortBy = this.sortBy;
                options.direction = this.direction;
            }
            return { filter, ...options };
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
    .app-virtual-table-dynamic-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        padding: 0;
    }

    .app-virtual-table-dynamic {
        height: 100%;
        width: 100%;
        position: relative;
    }
}

.app-data-table-editable::v-deep .header-column:last-child {
    width: 8.75rem;
}
.app-data-table-editable::v-deep .table-column:last-child {
    width: 8.75rem;
}
.overflow-visible {
    overflow: visible;
}
.clickable {
    cursor: pointer;
}
.edit-button {
    height: 1.5rem;
    width: 2.25rem;
}
</style>
